import React from 'react';
import { Card, CardContent, Typography, Avatar, Box, Grid } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'; 
const DashboardCards = ({ CountUser }) => {
    const iconMap = {
        'Total Agent Count': <PeopleIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Total ICA Agent Count': <EmojiPeopleIcon style={{ color: '#3674c4',fontSize: '35px'}} />,
        'New Lead Count':  <BarChartIcon style={{ color: '#3674c4',fontSize: '35px' }} />,
        // 'Switch Request Count': <SwapHorizIcon style={{ color: '#3674c4',fontSize: '35px' }} />,
    };
    return (
        <div>
            <Grid container spacing={2}>
                {[
                    { label: 'Total Agent Count', value: CountUser?.agent_count },
                    { label: 'Total ICA Agent Count', value: CountUser?.isa_agent_count },
                    { label: 'New Lead Count', value: CountUser?.new_lead_count },
                    // { label: 'Switch Request Count', value: CountUser?.shifted_agent_count },
                ]?.map((item, index) => (
                    <Grid item xs={12} sm={4} md={4} lg={4} key={index}>
                        <Card
                            sx={{
                                borderRadius: '20px',
                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                background: 'linear-gradient(#26c7f3, #316ec1)',
                            }}
                        >
                            <CardContent>
                                <Box style={{ padding: '15px' }}>
                                    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Avatar
                                            sx={{
                                                bgcolor:'#fff',
                                                width: { xs: '30px', sm: '50px', md:'50px', lg:'60px' },
                                                height: { xs: '30px', sm: '50px', md:'50px', lg:'60px' },
                                            }}
                                        >
                                            {iconMap[item?.label]}
                                        </Avatar>
                                        <Typography
                                            sx={{
                                                fontSize: { xs: '20px', sm: '24px' }, // Responsive font sizes
                                                fontWeight: 'bold',
                                                color: 'white',
                                                fontFamily: 'inherit',
                                            }}
                                        >
                                            {item?.value}
                                        </Typography>
                                    </Box>
                                    <Box style={{ marginTop: '20px' }}>
                                        <Typography sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, color: 'white' ,fontWeight: 'bold', fontFamily: 'inherit',}}>{item?.label}</Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default DashboardCards;
